module.exports = __webpack_public_path__ + "static/img/ys_bg.7ad3fd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ys_bg.jpg
// module id = zYcj
// module chunks = 0